import { __ } from 'i18n/index';

// Mirrors services\matchmaking\settings\RatingGap and RematchCooldown. 0 means no limit.
export const ratingGapOptions = () => [
	{ value: 0, label: __('Any') },
	{ value: 300, label: __('Wide (300)') },
	{ value: 150, label: __('Moderate (150)') },
	{ value: 100, label: __('Close (100)') },
	{ value: 50, label: __('Strict (50)') },
];

export const rematchCooldownOptions = () => [
	{ value: 0, label: __('Anytime') },
	{ value: 1, label: __('1 hour') },
	{ value: 3, label: __('3 hours') },
	{ value: 6, label: __('6 hours') },
	{ value: 12, label: __('12 hours') },
	{ value: 24, label: __('24 hours') },
];

const ratingGapAllows = (gap, rating, otherRating) => {
	if(!gap || rating === null || rating === undefined || otherRating === null || otherRating === undefined) {
		return true;
	}
	return Math.abs(rating - otherRating) <= gap;
};

const cooldownBlocks = (hours, lastPlayedAt, now) => !!hours && lastPlayedAt !== null && lastPlayedAt !== undefined
	&& lastPlayedAt > now - hours * 3600;

/**
 * Which of the two players' matchmaking settings rule the pair out, as
 * MatchSearchFilterReasons keys. Both players' settings count, as on the server.
 */
export function matchmakingRestrictionReasons({ mySettings, myRating, theirSettings, theirRating, lastPlayedAt, now }) {
	const mine = mySettings || {};
	const theirs = theirSettings || {};
	const reasons = [];
	if(!ratingGapAllows(mine.rating_gap, myRating, theirRating)) {
		reasons.push('RATING_GAP_MY_SETTING');
	}
	if(!ratingGapAllows(theirs.rating_gap, theirRating, myRating)) {
		reasons.push('RATING_GAP_THEIR_SETTING');
	}
	if(cooldownBlocks(mine.rematch_cooldown_hours, lastPlayedAt, now)) {
		reasons.push('REMATCH_COOLDOWN_MY_SETTING');
	}
	if(cooldownBlocks(theirs.rematch_cooldown_hours, lastPlayedAt, now)) {
		reasons.push('REMATCH_COOLDOWN_THEIR_SETTING');
	}
	return reasons;
}

// A search lists who the searcher played in the last 24 hours on its ladder.
export function lastPlayedAgainst(recentOpponents, playerId) {
	const found = (recentOpponents || []).find((opponent) => Number(opponent.player_id) === Number(playerId));
	return found ? found.played_at : null;
}

// An unplaced league has a null name; its default rating says nothing yet.
export function leagueRating(league) {
	if(!league || !league.name) {
		return null;
	}
	const rating = league && league.stats_serialized ? league.stats_serialized.rating : null;
	return rating === null || rating === undefined ? null : Number(rating);
}
